module.exports = __webpack_public_path__ + "img/add-dam-sire.2ef89cd0.png";